import { Checkbox, Col, Form, Input, Space } from "antd";
import { useState } from "react";

const rules = {
  required: [{ required: true, message: "Campo obrigatório!" }],
  requiredNoMessage: [{ required: true, message: "" }],
};

const MultipleQuestion = ({ loading, obrigatorio, questao, id, alternativas, defaultValue = [] }) => {
  const [value, setValue] = useState(defaultValue);

  return (
    <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
      <Form.Item
        initialValue={defaultValue}
        name={["multiple", `${id}`]}
        label={<strong>{questao}</strong>}
        rules={obrigatorio === 1 ? rules.required : null}>
        <Checkbox.Group disabled={loading} onChange={(val) => setValue(val)}>
          <Space direction="vertical">
            {alternativas?.map((alternativa) => {
              return (
                <Checkbox defaultChecked key={alternativa.id} value={alternativa.id}>
                  {alternativa.alternativa}
                  {value.includes(alternativa.id) && alternativa.exige_complemento === 1 && (
                    <Form.Item name={["complement", `${alternativa.id}`]} rules={rules.requiredNoMessage}>
                      <Input size="large" disabled={loading} placeholder={"Complemento"} />
                    </Form.Item>
                  )}
                </Checkbox>
              );
            })}
          </Space>
        </Checkbox.Group>
      </Form.Item>
    </Col>
  );
};

export { MultipleQuestion };
